<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{currentViewAll.title | translate}}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình tái sử dụng thiết kế-->
      
      <!-- CHỮ VÀ ĐỊNH DẠNG-->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">
            <!-- Lựa chọn hiển thị cho các thiết bị -->
            <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
            </app-hide-show-config>
            <!-- Hiển thị đơn vị tiền tệ -->
            <div class="">
              <p>{{'dinh_dang_thoi_gian' | translate}}</p>
              <nz-radio-group [(ngModel)]="config['date_format_style']" (ngModelChange)="updateObject()">
                <label nz-radio nzValue="dd-MM-yyyy">DD-MM-YYYY</label>
                <label nz-radio nzValue="dd-MM-yyyy, HH:mm">DD-MM-YYYY, TIME</label>
                <label nz-radio nzValue="dd/MM/yyyy">DD/MM/YYYY</label>
                <label nz-radio nzValue="dd/MM/yyyy, HH:mm">DD/MM/YYYY, TIME</label>
              </nz-radio-group>
            </div>

            <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
              [config]="config"  [staticdata]="staticdata"
              [textContentClass]="class['date-bill__content']" [textWrapperClass]="class['date-bill__wrapper']">
            </app-text-format-config>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div class="font-text-letterspacing">
                  <div class="config-name" style="gap:5px">
                    <p class="m-0" style="line-height:1.5">{{'khoang_cach_chu' | translate}}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                      [ngModel]="class['date-bill__content']['letter-spacing'] | vhnumber" (nzBlur)="updateClass()"
                      (ngModelChange)="class['date-bill__content']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['date-bill__content']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class['date-bill__content']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div class="font-text-linespacing">
                  <div class="config-name">
                    <p class="m-0" style="line-height:1.5">{{'khoang_cach_dong' | translate}}</p>
                    <nz-input-number [ngStyle]="{ width: '40%' }"
                      [(ngModel)]="this.class['date-bill__content']['line-height']" (nzBlur)="updateClass()"
                      [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['date-bill__content']['line-height']" (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- PHONG CÁCH -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-text-style-config [config]="config" [class]="class" [staticdata]="staticdata" [device]="device"
          [objectChoosing]="objectChoosing" [textContentClass]="class['date-bill__content']"
          [textWrapperClass]="class['date-bill__wrapper']" [filterConfig]="config['filter']" [isShape]="false">
        </app-text-style-config>
      </li>
      <!-- Cấu hình xoay-->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay' | translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-rotate-config [classRotate]="class['date-bill']" [config]="config" [device]="device"
          [objectChoosing]="objectChoosing"></app-rotate-config>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" [id_object]="objectChoosing._id" [device]="device" [class]="class"
          [config]="config" [staticdata]="staticdata" [cursorClass]="class['date-bill']" [effect_hover]="effect_hover"
          [customize]="customize" [type]="'object'" (openAnimationDetail)="openAnimationDetail($event)">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="this.config['animation-selected'].id != '000000'">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
  </div>
</div>